import React, { useEffect } from "react";
import { auth, db } from "../firebase";
import {
  doc,
  updateDoc,
  arrayUnion,
  serverTimestamp,
  Timestamp,
} from "firebase/firestore";
import "../styles/PaymentSuccessModal.css";

const PaymentSuccessModal = ({ onClose }) => {
  useEffect(() => {
    const processPayment = async () => {
      try {
        const user = auth.currentUser;
        if (!user) {
          onClose();
          return;
        }

        const now = new Date();
        let endDate = new Date(now);

        // 항상 한 달로 설정
        endDate.setMonth(endDate.getMonth() + 1);

        await updateDoc(doc(db, "users", user.uid), {
          subscription: {
            startDate: Timestamp.fromDate(now),
            endDate: Timestamp.fromDate(endDate),
            status: "active",
          },
          purchaseHistory: arrayUnion({
            purchaseDate: Timestamp.fromDate(now),
            packageType: "1month", // 기본값으로 설정
          }),
        });

        setTimeout(() => {
          onClose();
          window.location.reload();
        }, 3000);
      } catch (error) {
        alert("오류가 발생했습니다. 관리자에게 문의해주세요.");
        onClose();
      }
    };

    processPayment();
  }, [onClose]);

  return (
    <div className="payment-success-modal-overlay">
      <div className="payment-success-modal-content">
        <h2>결제가 완료되었습니다!</h2>
        <p>프리미엄 서비스 이용이 곧 시작됩니다.</p>
        <div className="loading-spinner"></div>
      </div>
    </div>
  );
};

export default PaymentSuccessModal;
